import {json} from '../../../core/data-source/json.mapper';

function generateColor(n: number): string {
    const h = (n * 137.508) % 360;
    return 'hsl(' + h + ', 50%, 50%)';
}
export class DriverPerformanceReportRecord {
    @json() averageDropTime: number;

    @json() averageTimeDeviation: number;

    @json() completedDeliveries: number;

    @json() correctSequence: number;

    @json() onTimeDeliveries: number;

    @json() performerName: string;

    @json() driverExternalId: string;

    @json() resourceName: string;

    @json()
    id: number;

    @json({
        jsonName: 'id',
        mapper: {
            from: (value: number) => generateColor(value)
        }
    })
    color: string;
}
